import { CustomAttributeFieldConfig } from 'src/graphql/entities/custom-attributes/field-view-registry/types';
import { getKindLikeValueSafely } from 'src/graphql/entities/custom-attributes/field-view-registry/utils';
import { toStringArray } from 'src/utils/objects';
import { MultiSelectEditor } from './multi-select-edit';
import { MultiSelectView } from './multi-select-view';

export const MULTI_SELECT_FIELD_CONFIG: CustomAttributeFieldConfig = {
  type: 'multi_select',
  editable: true,
  View: MultiSelectView,
  Editor: MultiSelectEditor,
  decode: (raw) => ({ kind: 'multi_select', value: toStringArray(raw) }),
  encode: (value) => {
    const list = getKindLikeValueSafely(value, 'multi_select') ?? [];

    return list.length === 0 ? null : list;
  },
  isEmpty: (value) => {
    const list = getKindLikeValueSafely(value, 'multi_select') ?? [];

    return list.length === 0;
  },
};
